module.exports = __webpack_public_path__ + "assets/878bb3d64fd4b494b0fc295f24b0bda0.mp4";